const isSafari = () => /^(?=.*Safari)(?!.*Chrome)/.test(navigator.userAgent);
export class ViewTimer {
  private startTime: number;

  constructor() {
    this.startTime = Date.now();
  }

  resetStartTime() {
    this.startTime = Date.now();
  }

  getStartTime() {
    return this.startTime;
  }

  getDuration() {
    const endTime = Date.now();
    const duration = endTime - this.startTime;
    return duration;
  }

  trackVisibilityChange(cb: (interval: number) => void) {
    const onVisibilityChange = () => {
      // tab hidden
      if (document.visibilityState === 'hidden') {
        const duration = this.getDuration();
        return cb(duration);
      }
      // tab show
      else if (document.visibilityState === 'visible') {
        this.resetStartTime();
      }
      return null;
    };
    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      return null;
    };
  }

  trackBeforeUnload(cb: (interval: number) => void) {
    const onBeforeUnload = () => {
      // only report event when user close the tab in view
      if (document.visibilityState === 'visible') {
        const duration = this.getDuration();
        return cb(duration);
      }
      return null;
    };
    window.addEventListener('beforeunload', onBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', onBeforeUnload);
      return null;
    };
  }

  trackPageHideAndShow(cb: (interval: number) => void) {
    const onPageHide = () => {
      const duration = this.getDuration();
      return cb(duration);
    };
    const onPageShow = () => {
      this.resetStartTime();
    };
    window.addEventListener('pagehide', onPageHide);
    window.addEventListener('pageshow', onPageShow);
    return () => {
      window.removeEventListener('pagehide', onPageHide);
      window.removeEventListener('pageshow', onPageShow);
    };
  }

  addListener(cb: (interval: number) => void) {
    let removeBeforeUnloadListener = () => {
      // noop
    };
    // only listen beforeunload in safari, because others will trigger visibilitychange while closing the tab
    if (isSafari()) {
      removeBeforeUnloadListener = this.trackBeforeUnload(cb);
    }
    const removeVisibilityListener = this.trackVisibilityChange(cb);
    return () => {
      removeBeforeUnloadListener();
      removeVisibilityListener();
    };
  }
}
